import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import Seo from '../../../../components/Misc/Seo';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_1.png';
import projectImage2 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_2.png';
import projectImage3 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_3.png';
import projectImage4 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_4.png';
import projectImage5 from '../../../../assets/images/work/norcat-mine-experience/NORCATMineExperience_Slider_5.png';

import Data_NORCATMineExperience from './Data_NORCATMineExperience';

function Work_NORCATMineExperience() {
    const siteUrl = 'https://studio.norcat.org';
    const canonical = 'https://studio.norcat.org/OurWork/norcat-mine-experience';
    const title = 'NORCAT Mine Experience | Virtual Underground Mine Tour by Studio NORCAT';
    const description =
        'The NORCAT Mine Experience is a virtual underground mine tour from Studio NORCAT that builds foundational awareness of the mining lifecycle through guided, scenario-based learning.';
    const socialImage = `${siteUrl}${projectImage1}`;
    const structuredData = {
        '@context': 'https://schema.org',
        '@type': 'CreativeWork',
        name: 'NORCAT Mine Experience',
        headline: title,
        description,
        url: canonical,
        image: [socialImage],
        creator: {
            '@type': 'Organization',
            name: 'NORCAT Studio',
            url: siteUrl,
        },
        publisher: {
            '@type': 'Organization',
            name: 'NORCAT Studio',
            url: siteUrl,
            logo: {
                '@type': 'ImageObject',
                url: `${siteUrl}/assets/images/favicon/android-chrome-512x512.png`,
            },
        },
        inLanguage: 'en',
        keywords: [
            'NORCAT Mine Experience',
            'virtual mine tour',
            'underground mining orientation',
            'scenario-based learning',
            'experiential learning',
            'mining lifecycle training',
        ],
    };

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={socialImage}
                ogImageAlt="Preview of the NORCAT Mine Experience project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={socialImage}
                twitterImageAlt="Preview of the NORCAT Mine Experience project"
            />
            <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            <DetailedHeader
                heading="Discover Mining Through a Virtual Tour"
                client="NORCAT / Internal"
                service="Experiential Learning"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Learner arriving at the NORCAT Underground Centre portal in the NORCAT Mine Experience',
                    },
                    {
                        image: projectImage2,
                        alt: 'Virtual underground travel scene highlighting mine access and navigation concepts',
                    },
                    {
                        image: projectImage3,
                        alt: 'Mine infrastructure scene showing underground equipment and operating environment details',
                    },
                    {
                        image: projectImage4,
                        alt: 'Production area scene illustrating mining workflow and situational awareness',
                    },
                    {
                        image: projectImage5,
                        alt: 'Guided underground learning moment from the NORCAT Mine Experience virtual tour',
                    },
                ]}
            />

            {Data_NORCATMineExperience.content}
        </>
    );
}

export default Work_NORCATMineExperience;
